/**
 * Converts a LKP_DRILLDOWN_CONFIG flex value to a pixel column width.
 * Each 0.1 unit of flex = 5px (e.g., flex 0.5 → 25px, flex 1.0 → 50px, flex 1.8 → 90px).
 * Minimum width is 20px.
 */
export const flexToWidth = (flex) => {
  if (flex == null || isNaN(flex)) return 80; // sensible default
  return Math.max(Math.round(flex * 50), 20);
};

export function generateIntegerAbove99() {
  var randomNumber =
    Math.floor(Math.random() * (Number.MAX_SAFE_INTEGER - 99)) + 100;
  return randomNumber;
}
export const MAC_BROWSER_WIDTH = 0.85;
export const dashboardRecommnedationString = (
  dashboards
) => `The following dashboard${
  dashboards.length > 1 ? "s" : ""
} can provide you more information:
${dashboards.map((it) => it).join(",")}`;
export const replaceDynamicValueLabel = (str, valueLabel) => {
  const regex = /acv/gi; // "g" for global, "i" for case-insensitive
  const replacedString = str.replace(regex, valueLabel);
  return replacedString;
};
